import Config from '../../config';

import Collection from '../../collection';
import Stats from '../../collection/schedule/stats';

import { unixts, datify, fmt } from '../../utils/date';





export default Collection.extend( {

    responseAt: 'items',
    countAt: 'total',

    url({ filters: { date }/*, page, activeId */}) {
        return Config.url( `timetables/runs/${fmt( date, 'YYYY-MM-DD' )}?apiVersion=2.0` );
    },

    parseResponse(modelsAttrs/*, response*/) {
        return modelsAttrs
            // generate id by client-side
            .map( batch => {
                batch.id = batch.id || Math.random() * 1e12 | 0;
                batch.runs.forEach( parseRun );
            } ), modelsAttrs;
    },
} );

function parseRun(payload) {
    // date here is unix ts
    const now = unixts( new Date() );
    const { date, time } = payload;
    const datetime = datify( `${date} ${time}:00` );
    // now - 15 mins
    if (unixts( datetime ) > now - 15 * 60)
        payload.planned = true;

    Stats.extendStats( payload.stats );
}


// WEBPACK FOOTER //
// ./src/js/collection/schedule/runs.js